import React, { Component } from 'react';
import './index.scss';

class AgreementNew extends Component {
  componentDidMount() {
    try {
      const agentName = window.mstJsBridge.getAgentName();
      if (agentName === 'IOS') {
        const {
          location: {
            hash,
          },
        } = window;
        if (hash.indexOf('#refund') !== -1) {
          const t = document.body.clientHeight;
          window.scroll({ top: t, left: 0 });
        }
      }
    } catch (e) {
      console.log('ios页面出错：', e);
    }
  }

  render() {
    return (
      <div className="agreement-box">
        <h1>
          EWT360用户协议
        </h1>
        <br />
        <h2>
          一、说明
        </h2>
        <p className="text">
          本用户协议双方为EWT360（公司全称：江西铭师堂数字技术有限公司）与EWT360用户（含未成年人学员及其监护人），本用户协议具有合同效力。
        </p>
        <p className="text">
          本用户协议内容包括协议正文及所有EWT360已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。
        </p>
        <p className="text">
          用户在使用EWT360提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。EWT360根据需要制定、修改本协议或各类规则，
          <strong>
            <u>经修订的协议在EWT360网站、客户端等公布后生效，亦成为本协议的一部分，继续使用服务将表示用户接受经修订的协议。</u>
          </strong>
          除另行明确声明外，任何使服务范围扩大或功能增强的新内容均受本协议约束。
        </p>
        <p className="text">
          用户必须是具备使用EWT360相应民事行为能力的自然人。
          <strong>
            <u>用户保证：在EWT360所有的付费行为均由家长确认后并由家长账户自愿进行支付。</u>
          </strong>
          用户确认本用户协议后，本用户协议即在用户和EWT360之间产生法律效力。请用户务必在注册之前认真阅读全部用户协议内容，如有任何疑问，可向EWT360咨询。
        </p>
        <br />
        <h2>
          二、 用户权利和义务：
        </h2>
        <p>
          <strong>
            所有用户必须遵循：
          </strong>
        </p>
        <p className="text">
          - 遵守所有使用网络服务的网络协议、规定、程序和惯例；
        </p>
        <p className="text">
          - 不得使用EWT360从事违法活动；
        </p>
        <p className="text">
          - 不得干扰或侵犯EWT360的正常运行和其他用户的正常使用；
        </p>
        <p className="text">
          - 未经允许，不得以任何形式下载或试图下载EWT360的任何内容；
        </p>
        <p className="text">
          - 用户购买的服务只允许个人使用，不能用于其他目的，包括不限于不得复制、传播；
        </p>
        <p className="text">
          -  从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。
        </p>
        <br />
        <p>
          <strong>
            同时用户承诺：
          </strong>
        </p>
        <p>
          （1）不得利用EWT360制作、复制、查阅和传播下列信息：
        </p>
        <p className="text">
          -任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；
        </p>
        <p className="text">
          -任何教唆他人进行违法犯罪行为的资料；
        </p>
        <p className="text">
          -不利于国内团结和社会安定的资料；
        </p>
        <p className="text">
          -任何不符合国家法律、法规规定的资料、信息；
        </p>
        <p className="text">
          -任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；
        </p>
        <p className="text">
          -损害EWT360声誉和商业利益的信息；
        </p>
        <p>
          （2）不得未经许可而非法进入其它个人或组织电脑系统；
        </p>
        <p>
          （3）未经允许，不得对EWT360中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；
        </p>
        <p>
          （4）不得故意制作、传播计算机病毒等破坏性程序；
        </p>
        <p>
          （5）法律规定的其他义务。
        </p>
        <br />
        <p>
          <strong>基于网络服务的特殊性，用户同意：</strong>
        </p>
        <p className="text">
          - 在注册时按照注册提示提供准确用户名和密码以及详尽的个人资料；
        </p>
        <p className="text">
          - 在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为EWT360提供所有服务的有效身份依据。
        </p>
        <p className="text">
          -  用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；
        </p>
        <p className="text">
          - 用户应自行负担因使用这种接入方式而产生的上网电话费、上网信息费及教育信息费。
        </p>
        <p className="text">
          - 用户一旦注册成功，成为EWT360的正式用户后，应当对自己的账号、密码的安全性负全部责任。用户的密码只能由用户自己掌握。
        </p>
        <p className="text">
          - 对于用户因账号或密码泄露造成的各种损失，EWT360不承担任何责任。用户发现任何非法使用用户账号的情况，应立即通知EWT360。
        </p>
        <p className="text">
          - 用户应对以其账号进行的所有活动和事件负责。
        </p>
        <p className="text">
          <strong>
            <u>- 账号只为注册用户本人所专有，不得将账号出借他人使用，严禁一个账号多人使用，如果用户违反此规定，EWT360将有权将此账号作为无效处理并保留追究法律责任的权利。</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>- 对于侵犯EWT360知识产权的账号，EWT360将有权将此账号做封号、注销处理并保留追究法律责任的权利。</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>- 所有购买的服务都有截止登录时间，用户应在指定日期前登录，否则用户不得再行登录，用户自己应对此承担全部责任。</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>- 同意通过提供的手机号码、QQ号、电子邮箱等联系方式，接受EWT360发送的验证码、通知等产品或公司相关信息。</u>
          </strong>
        </p>
        <br />
        <h2>
          三、EWT360的权利和义务：
        </h2>
        <p className="text">
          EWT360有义务在现有技术上维护整个平台的正常运行，并努力提升和改进技术，使用户网络教育活动得以顺利进行。同时，对用户在注册使用EWT360中所遇到的与交易或注册有关的问题及反映的情况，EWT360应及时作出回复。
        </p>
        <p className="text">
          EWT360享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。
          <strong>
            <u>对于用户在EWT360的不当行为或其它任何EWT360认为应当终止服务的情况，EWT360有权作出删除相关信息、终止服务提供等处理；</u>
          </strong>
          EWT360应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于战争、自然灾害、传染性疾病等不可抗力或者其它非人为因素造成的服务的中断或停止，EWT360及用户互不承担违约责任。
        </p>
        <p className="text">
          EWT360内以任何形式表现的作品（包括但不限于视频、文字、软件、声音、图片、录像、表格、电子邮件等）的知识产权，由EWT360享有或已获授权。用户未经许可，不得擅自对EWT360的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法、专利法等相关法律、法规的活动。对侵犯EWT360知识产权的个人和组织，EWT360或相关权利人将依法追究其民事或刑事责任。
        </p>
        <p className="text">
          EWT360有许可使用权。EWT360对用户在网上发表的供学习交流的作品，在获得授权同意后享有出版、发行和复制的权利。用户以此授予EWT360及其关联公司使用、复制、修订、改写、发布、翻译、分发、展示用户的作品。
        </p>
        <p className="text">
          EWT360会在用户的计算机上设定或取用EWT360cookies。EWT360允许那些在EWT360上发布广告的公司到用户计算机上设定或取用cookies。在用户登录时获取数据，
          <strong>
            <u>EWT360使用cookies可为用户提供个性化服务。</u>
          </strong>
          如果拒绝所有 cookies，用户将不能使用需要登录的EWT360产品及服务内容。
        </p>
        <p className="text">
          EWT360对用户协议有修改和完善的权利。1、EWT360将根据互联网的发展和法律、法规的变化等修改用户协议并获取用户同意。2、如果不同意所改动的内容，用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，应同意接受用户协议的变动。
          <strong>
            <u>当发生争议时，应以最新用户协议的内容为准。</u>
          </strong>
        </p>
        <p className="text">
          如用户向EWT360提出注销EWT360注册用户身份时，经EWT360审核同意，由EWT360注销该注册用户，用户即解除与EWT360的用户协议关系。但注销该用户账号后，如用户在注销前在EWT360上存在违法行为或违反合同的行为，EWT360仍可行使本用户协议所规定的权利。
        </p>
        <p className="text">
          如用户有任何违反本协议的行为，EWT360可以做出独立判断，
          <strong>
            <u>删除相关具有违法性、侵权性、不当性等内容,并有权立即采取封号、注销账号等措施。用户应对自己在EWT360上的违法行为承担全部法律责任。</u>
          </strong>
          但如该用户在被EWT360终止提供服务后，再一次直接或间接或以他人名义注册为EWT360用户的，EWT360有权再次单方面终止向该用户提供服务。
        </p>
        <br />
        <h2>
          四、责任范围：
        </h2>
        <p className="text">
          用户明确理解和同意，EWT360不对下述情况导致的损失承担赔偿责任，
          <strong>
            <u>损失包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失：</u>
          </strong>
        </p>
        <p className="text">
          （1）因不可抗力、计算机病毒或黑客攻击、用户所在位置、电脑故障、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求或遭受损失，EWT360不承担责任但将尽力减少因此而给用户造成的损失和影响。
        </p>
        <p className="text">
          （2）如因用户违反有关法律或者本协议之规定，使EWT360遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对EWT360的损失承担赔偿责任，包括合理的律师费用等。
        </p>
        <br />
        <h2 id="refund">
          五、退款说明
        </h2>
        <p className="text">
          1.用户自购买EWT360之日起的3个自然日内，可向客服申请退款。
        </p>
        <p className="text">
          <strong>
            <u>2.存在以下任何一种情况的，不能退款：</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>（1）因6月7日-6月31日（含7日和31日当天）为志愿填报高峰期，在其期间购买的。</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>（2）反复恶意退款者（同一用户退款≥2次）再次购买后；</u>
          </strong>
        </p>
        <p className="text">
          <strong>
            <u>（3）存在违法、侵害他人权益、或侵害EWT360权益等行为，包括但不限于一个账号多人使用。</u>
          </strong>
        </p>
        <p className="text">
          3.e币或t币购买后不得退款。
        </p>
        <p className="text">
          4.退款到账时间：符合退款要求的用户，将在申请退款之日起的10个工作日内收到退款。
        </p>
        <br />
        <h2>
          六、法律与管辖：
        </h2>
        <p className="text">
          本用户协议根据现行中华人民共和国法律法规制定。如发生协议条款与中华人民共和国法律法规相抵触时，则这些条款将完全按法律法规的规定重新解释，本用户协议的其它条款仍对EWT360和用户具有法律约束力。
          {/* <strong>
            <u>因本用户协议而发生的任何争议应向对杭州市上城区人民法院提起诉讼。</u>
          </strong> */}
        </p>
      </div>
    );
  }
}
export default AgreementNew;



// WEBPACK FOOTER //
// ./src/components/pages/agreementNew2/index.jsx